import { Button } from '@client/toolkit';

export interface TabsMenuProps {
  options: {
    id: string;
    label: string;
    startDate?: Date;
    endDate?: Date;
  }[];
  selected: string;
  onSelect: (key: string) => void;
  disabled?: boolean;
}

export function TabsMenu({ options, selected, onSelect, disabled }: TabsMenuProps) {
  return (
    <div className="flex p-1 gap-1 rounded-md bg-surface-elevated/30">
      {options.map((option) => (
        <Button
          key={option.id}
          size="sm"
          color={selected === option.id ? 'primary-invert' : 'none'}
          className={selected === option.id ? 'text-primary' : 'text-secondary'}
          onClick={() => {
            if (option.id !== 'custom') onSelect(option.id);
          }}
          disabled={disabled || (option.id === 'custom' && selected !== 'custom')}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
